export const isTextCutOff = (node: HTMLElement) => {
  return node?.offsetWidth < node?.scrollWidth;
};
